export default function CrmDashTwoIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="#ABEBF4"
        d="M15.194 18.415h-3.1V7.594c0-.683.554-1.237 1.236-1.237h.627c.683 0 1.237.554 1.237 1.237v10.82z"
      />
      <path
        fill="#8ED7E8"
        d="M15.194 13.136c-.943.442-1.98.827-3.1 1.105v4.174h3.1v-5.279z"
      />
      <path
        fill="#B2E59C"
        d="M10.747 18.415h-3.1v-8.09c0-.595.483-1.078 1.078-1.078h.943c.596 0 1.079.483 1.079 1.078v8.09z"
      />
      <path
        fill="#FFDE55"
        d="M19.64 16.686h-3.1V4.2c0-.678.55-1.228 1.229-1.228h.642c.679 0 1.229.55 1.229 1.228v12.486z"
      />
      <path
        fill="#FFCD00"
        d="M19.64 10.247a20.226 20.226 0 01-3.1 2.19v4.25h3.1v-6.44z"
      />
      <path
        fill="#FFE2D9"
        d="M6.28 14.473l6.233-3.308a1.042 1.042 0 011.51 1.128c-.128.631-.421 1.297-1.033 1.793l-.64.517a.433.433 0 00.273.77l2.562.002c.835 0 1.65-.258 2.334-.738l2.862-2.013a1.346 1.346 0 011.629 2.14l-3.75 3.081c-.47.386-1.02.661-1.61.806l-8.218 2.012-2.152-6.19z"
      />
      <path
        fill="#FFCFC2"
        d="M9.733 17.722C7.373 17.03 7.55 13.8 7.55 13.8l-1.269.673 2.152 6.19 6.264-1.534c-1.32-.367-3.443-.961-4.963-1.407z"
      />
      <path
        fill="#8ED7E8"
        d="M6.28 14.473l2.329 6.216a1.816 1.816 0 01-1.298 2.407l-2.227.506a1.816 1.816 0 01-2.16-1.314l-1.2-4.615a1.87 1.87 0 011.297-2.268l3.259-.932z"
      />
      <path
        fill="#7AC1DD"
        d="M8.609 20.689l-.363-.97c-.932-.434-1.94-.52-2.755-.487a1.821 1.821 0 01-1.901-1.877c.037-1.16.28-2.193.28-2.193l-.85.242a1.87 1.87 0 00-1.295 2.27l1.2 4.614a1.816 1.816 0 002.159 1.314l2.227-.506a1.816 1.816 0 001.298-2.407z"
      />
      <path
        fill="#FFEB99"
        d="M6.582 21.037a1.033 1.033 0 11-2.067 0 1.033 1.033 0 012.067 0z"
      />
      <path
        fill="#97F7E5"
        d="M14.39.352h-2.81a.73.73 0 000 1.46h1L9.648 4.633l-1.39-.72a.73.73 0 00-.853.135l-5.67 5.713A.73.73 0 102.77 10.79l5.292-5.333 1.38.714a.73.73 0 00.84-.123l3.378-3.25v1.12a.73.73 0 101.46 0v-2.84c0-.584-.433-.727-.73-.727z"
      />
      <path
        fill="#000"
        d="M22.37 12.538c-1.104-1.098-2.378-.07-2.378-.07v-5.78a.352.352 0 00-.704 0v6.274s-1.676 1.322-2.396 1.645V4.2c0-.484.393-.877.877-.877h.642c.484 0 .877.393.877.877v1.05a.351.351 0 10.704 0V4.2c0-.871-.71-1.58-1.58-1.58h-.643c-.871 0-1.58.709-1.58 1.58v10.686c-.21.058-.425.098-.644.12V7.593a1.59 1.59 0 00-1.588-1.588h-.627a1.59 1.59 0 00-1.588 1.588v3.582l-.643.341v-1.192c0-.788-.642-1.43-1.43-1.43h-.944c-.788 0-1.43.642-1.43 1.43v3.21l-1.147.61-3.224.921A2.21 2.21 0 001.606 16.1a2.21 2.21 0 00-.221 1.662l.36 1.387a.352.352 0 00.68-.177l-.36-1.387a1.51 1.51 0 011.053-1.843l2.947-.842 2.215 5.912a1.575 1.575 0 01-1.047 1.941l-2.227.506a1.458 1.458 0 01-1.741-1.06l-.452-1.74a.352.352 0 00-.681.178l.452 1.74A2.156 2.156 0 004.674 24c.71 0 2.715-.561 2.715-.561a2.167 2.167 0 001.64-2.56l7.705-1.887a4.433 4.433 0 001.75-.875l3.749-3.081c1.143-1.014.472-2.163.136-2.498zm-9.04-5.83h.627c.488 0 .885.398.885.886v7.429l-2.218-.001c-.204-.002-.063-.136-.052-.146l.639-.517c.596-.483.985-1.154 1.157-1.995a1.381 1.381 0 00-.531-1.395 1.381 1.381 0 00-1.392-.162V7.594c0-.488.397-.885.885-.885zM8 10.326c0-.4.326-.726.726-.726h.944c.4 0 .727.326.727.726v1.566L8 13.164v-2.838zm13.788 4.168l-3.75 3.08c-.426.35-.934.605-1.47.736l-7.762 1.9-2.087-5.57 5.96-3.164a.676.676 0 01.738.057c.22.164.318.423.263.691-.138.677-.445 1.212-.91 1.59l-.64.517a.777.777 0 00-.245.872.776.776 0 00.74.523l2.56.001h.003a4.38 4.38 0 002.534-.802l2.862-2.013a.99.99 0 011.283.119c.198.201.583.8-.08 1.463z"
      />
      <path
        fill="#000"
        d="M6.934 21.037a1.386 1.386 0 10-1.385 1.385c.763 0 1.385-.621 1.385-1.385zm-2.067 0a.683.683 0 111.365.001.683.683 0 01-1.365 0zM3.02 11.038l5.111-5.15 1.15.595c.411.213.912.14 1.246-.182l2.782-2.677s-.076 1.375 1.082 1.375c.596 0 1.081-.485 1.081-1.082V1.071C15.468.331 14.927 0 14.391 0h-2.812c-.596 0-1.08.485-1.08 1.081 0 1.19 1.209 1.082 1.209 1.082L9.586 4.206l-1.167-.604a1.077 1.077 0 00-1.264.2l-5.67 5.713a1.084 1.084 0 00.006 1.53c.204.201.9.622 1.53-.007zM1.985 10.01l5.67-5.714c.073-.073.19-.202.442-.069l1.39.719a.35.35 0 00.406-.06l2.932-2.821a.351.351 0 00-.244-.605h-1a.379.379 0 010-.757h2.81c.104 0 .379 0 .379.376v2.838a.379.379 0 01-.757 0v-1.12a.351.351 0 00-.595-.253l-3.377 3.25a.378.378 0 01-.436.064l-1.38-.713a.352.352 0 00-.41.065L2.52 10.543c-.23.23-.463.073-.535.002a.379.379 0 01-.002-.535z"
      />
    </svg>
  );
}
